module.exports = __webpack_public_path__ + "static/media/270x270.99f89571.png";